import {SiteEntity} from "../../commons/models/siteEntity.model";
import {ProcessTrackingStatusEnum} from "../../commons/types/process-tracking-status.enum";

export enum RecommendationHolderType {
  VisitPlan = 'VisitPlan',
  VisitSchedule = 'VisitSchedule',
  Planning = 'Planning'
}

export enum RecommendationTriggerType {
  VpSlotCreated = 'VpSlotCreated',
  VpAccountCreated = 'VpAccountCreated'
}

export enum RecommendationStatus {
  Expired = 'Expired',
  Active = 'Active'
}

export enum RecommendationSeverity {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High'
}

export enum RecommendationFeedback {
  NEGATIVE = "NEGATIVE",
  POSITIVE = "POSITIVE"
}

export enum InsightEntityType {
  VisitPlan = 'VisitPlan',
  VisitSlot = 'VisitSlot',
  VisitAccount = 'VisitAccount',
  Draft = 'Draft',
  Route = 'Route'
}

export enum InsightVariableTag {
  VisitSlotDate = 'VisitSlotDate',
  AccountName = 'AccountName',
  VisitPlanName = 'VisitPlanName',
  VisitAccountName = 'VisitAccountName',
  RouteIds = 'RouteIds'
}

export interface InsightOutputEntity {
  entityId: string;
  insightEntityType: InsightEntityType;
  tag?: InsightVariableTag;
  displayName: string;
  metadata?: any;
}

export interface RecommendationInsightOutput {
  insightEntities: InsightOutputEntity[];
  parameterizedMessage: string;
  parameterizedTitleMessage: string;
}

export enum RecommendationType {
  CustomizedInsight = 'CustomizedInsight',
  AiValidation = 'AiValidation'
}

export interface RecommendationModel extends SiteEntity {
  recommendationHolderType: RecommendationHolderType;
  recommendationHolderId: string;
  aiAgentId: string;
  configurationId: string;
  promptId: string;
  triggerType: RecommendationTriggerType;
  status: RecommendationStatus;
  severity: RecommendationSeverity;
  insightOutput: RecommendationInsightOutput;
  feedback: RecommendationFeedback;
  recommendationType?: RecommendationType;
  actionTypes?: string[];
  canApply?: boolean;
}

export interface RecommendationGroupModel {
  id: string;
  type: InsightEntityType;
  name: string;
  total: number;
}

export interface RecommendationProcessModel extends SiteEntity {
  processId: string;
  processStatus: ProcessTrackingStatusEnum;
  processType: string;
  progressMap: Object;
  errors: string[];
  agentId: string;
}
